<template>
    <div :class="computedColClass">
        <div :class="otherClass">

            <!-- LABEL -->
            <label v-if="title" :for="selectId" :class="labelClass">
                <slot name="title">{{ toTitleCase(title) }}</slot>
                <sup v-if="req" :class="spanClass">*</sup>
            </label>

            <!-- SLOT FOR V-SELECT -->
            <slot></slot>

            <!-- ERROR MESSAGE -->
            <Error
                v-if="hasError"
                :id="errorId"
                :message="errorMessage"
                :bootstrap="bootstrap"
            />
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useValidationStore } from '../../stores/validationStore.js';
import Error from '../Error.vue';

const props = defineProps({
    field: { type: String, required: true },
    selectId: { type: String, default: null },
    title: { type: String, default: '' },
    col: { type: String, default: '' },
    req: { type: Boolean, default: false },
    bootstrap: { type: Boolean, default: false },
    otherClass: { type: String, default: 'mb-3' }
});

// Validation store
const validationStore = useValidationStore();

// Compute field name, error, and IDs
const fieldName = computed(() => props.field.split('.').pop());
const selectId = computed(() => props.selectId ?? fieldName.value);
const errorId = computed(() => `error-${selectId.value}`);
const errorMessage = computed(() => validationStore.getErrors(fieldName.value));
const hasError = computed(() => validationStore.hasError(fieldName.value));

// Classes
const computedColClass = computed(() => props.col || (props.bootstrap ? 'col-12 col-md-6 col-lg-4' : 'col-span-12 md:col-span-6 lg:col-span-4'));
const labelClass = computed(() => props.bootstrap ? 'form-label' : 'block text-sm font-medium text-gray-700 mb-1');
const spanClass = computed(() => props.bootstrap ? 'text-danger' : 'text-red-500');

// Utility
const toTitleCase = str => {
    if (!str) return '';
    return str.replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
</script>

<style scoped>
/* For Tailwind styling, the slot <v-select> should already handle border/focus */
</style>
